import { Typography } from "@mui/material"

function TextFeildView({ label, value, sx }) {
    return <Typography sx={{ mt: 0, letterSpacing: 0.5, fontSize: "16px", ...sx }}>
        <Typography as="span" sx={{ fontWeight: 500, textTransform: "capitalize", fontSize: "16px" }}>{label}</Typography> :- {value}
    </Typography>
}
export default TextFeildView